import React from "react";

const Footer = () => {
  return (
    <footer className="flex justify-center mt-32 border-t-blue-300 border-t-4 pt-4">
      Outil conçu pour le&nbsp;
      <a
        className="text-blue-400 hover:text-blue-800"
        href="https://chiffroscope.blogs.laclasse.com/"
      >
        Chiffroscope
      </a>
    </footer>
  );
};

export default Footer;
